// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-players-information__container {
    padding: var( --space-and-half );
    background: var(--white-color);    
}

.tournament-players-information-team-info .baloa-normal-medium {
    color: var(--primary-very-dark-color);
}

.tournament-players-information-team-info .baloa-username {
    color: var(--primary-dark-color);
}

.tournament-players-information-setup__img img {
    width: 47px;
    height: 47px;
    border-radius: 50%;
}

.tournament-players-information-setup__img .icon-ball {
    font-size: var(--space-x2);
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: var(--space-half);
    color: var(--white-color);
}

.tournament-players-information-setup__team-title{
    display: flex;
    align-items: center;    
    background: rgba(243, 245, 247, 0.6);
    padding: var(--space-half-quarter) var(--space);
    border-radius: var(--space-half) var(--space-half) 0 0;    
}

.tournament-players-information-setup__team-info:first-of-type {
    width: 35%;
    justify-content: flex-start;
}

.tournament-players-information-setup__team-info:last-of-type {
    width: 20%;
    justify-content: center;
}

.tournament-players-information-setup__team-info {
    display: flex;
    align-items: center;
    width: 15%;
}

.tournament-players-information-setup__team_width{
    width: 50%;
    text-align: end;
    position: relative;
    cursor: pointer;    
}

.tournament-players-information-setup__team_width .icon-options {
    font-weight: var(--font-bold);
}

.tournament-players-information-setup__filter-container{
    padding: 12px 16px;
    width:100%;
}

.tournament-players-information-player {
    min-height: calc( var( --space-x3 ) - var( --space-half ) );
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 4px;
}

.tournament-players-information-player .baloa-table-column {
    color: var(--primary-very-dark-color);
    display: flex;
    align-items: center;
    gap: 4px;
}

.tournament-players-information-setup__search-input input{
    background: transparent;
    width: 100%;
    border-style: none;
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc( var(--space) + 1px );
    line-height: calc( var(--space-and-half) - 2px );;
    display: flex;
    align-items: center;
    letter-spacing: 0.001em;
    color: var(--basic-gray-color);
    padding: var(--space-half-quarter) 0;
}

.tournament-players-information-setup__search-input {
    width: 32%;
    background: var(--new-gray-background-color);
    border-radius: calc( var(--space-and-half) - 2px );
}

.tournament-players-information-setup__search-input .MuiInput-underline:before,
.tournament-players-information-setup__search-input .MuiInput-underline:hover:not(.Mui-disabled):before {
    border: none;
}

.tournament-players-information-setup__search-input .icon-search {
    font-size: 20px;
    margin-left: var( --space-half );
    margin-right: var( --space-half-quarter );
    color: #949F9A;
}

.tournament-players-information-setup__team {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--space-and-half);
}

.tournament-players-information-setup__team img{
    height: 39px;
    width: 39px;
    border-radius: 50px;
} 

.tournament-players-information-setup__team .icon-ball {
    font-size: 28px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    height: 100%;
    color: var(--white-color);
    display: flex;
    justify-content: center;
    align-items: center;
}

.tournament-players-information-setup__team-data{
    display: flex;
    justify-content: initial;
    align-items: center;
    width: 248px;
}

.tournament-players-information-team-btn{
    display: flex;
    margin-top: 16px;
}

.tournament-players-information-btn-actions__payment-info,
.tournament-players-information-btn-actions__view-form,
.tournament-players-information-btn-actions__undone {
    cursor: pointer;
    display: flex;
    align-items: center;
}

.tournament-players-information-btn-actions__undone {
    cursor: auto;
}

.tournament-players-information-btn-actions__view-form .baloa-table-column,
.tournament-players-information-btn-actions__payment-info .baloa-table-column,
.tournament-players-information-team-btn-actions__view-form .baloa-table-column,
.tournament-players-information-team-btn-actions__payment-info .baloa-table-column {
    color: var( --new-green-color );
    margin-right: 10px;
    padding: 2px 6px;
    justify-content: center;
    border-radius: 25px;
    border: 1px solid var(--new-green-color);
    background: rgba(48, 179, 107, 0.15);
}

.tournament-players-information-btn-actions__undone .baloa-table-column,
.tournament-players-information-team-btn-actions__undone .baloa-table-column {
    color: var( --basic-gray-color );
    margin-right: var(--space-x3);
    padding: 2px 6px;
    justify-content: center;
    border-radius: 25px;
    border: 1px solid var(--basic-gray-color);
    background: rgba(113, 132, 123, 0.15);
}

.tournament-players-information-btn-actions__view-form span,
.tournament-players-information-btn-actions__payment-info span,
.tournament-players-information-team-btn-actions__view-form span,
.tournament-players-information-team-btn-actions__payment-info span {
    color: var(--basic-gray-color);
    opacity: 0.64;
    font-size: 20px;
}

.tournament-players-information-btn-actions__undone span{
    color: var(--error-color);
}

.tournament-players-information-team-btn-actions__view-form,
.tournament-players-information-team-btn-actions__payment-info{
    margin-right: var(--space-x3);
    cursor: pointer;
    display: flex;
    align-items: center;
}

.tournament-players-information-setup__team-info .baloa-table-column {
    color: var( --primary-very-dark-color );
}

.tournament-players-information-setup__team-info:last-of-type .baloa-table-column {
    margin-right: 84px;
}

.tournament-players-information-setup__teams-filter {
    display: flex;
    align-items: center;
}

.tournament-players-information__enrolled.baloa-table-column {
    color: var(--white-color );
    padding: var( --space-half ) var( --space );
    border-radius: var( --space-and-half );
    background:  var( --new-green-color);
    width: fit-content;
    margin-left: var(--space-half-quarter);
}

.tournament-players-information__pending.baloa-table-column {
    color: var(--white-color );
    padding: var( --space-half ) var( --space );
    border-radius: var( --space-and-half );
    background:  var( --basic-gray-color);
    width: fit-content;
}

.tournament-players-information-options{
    display: flex;
    align-items: flex-end;
    position: relative;
    margin-left: var(--space);
    cursor: pointer;
}

.tournament-players-information-options span{
    font-weight: var(--font-bold);
}

.tournament-players-information_options-box{
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    width: 380px;
    right: 0;
    top: 0;
    margin-right: calc( var(--space) + var(--space-quarter) );
    display: none;   
    border-radius: var(--space-half); 
    border: 1px solid var(--new-gray-background-color);
}

.tournament-players-information_options-box.active{
    display: block;    
}

.tournament-players-information_options-container{
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.tournament-players-information:first-of-type {
    width: 30%;
}

.tournament-players-information.staff:first-of-type {
    width: 35%;
}

.tournament-players-information:last-of-type {
    width: 20%;
}

.tournament-players-information {
    width: 15%;
}

.tournament-players-information__back-action-container {
    display: flex;
    align-items: center;
    margin: var(--space-and-half) 0;
}

.tournament-players-information__players-team__team-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tournament-players-information__team {
    display: flex;
    align-items: center;
    margin-bottom: var(--space-half-quarter);
}

.tournament-players-information__team-forms {
    display: flex;
}

.tournament-players-information__players-team__team-info {
    padding: var(--space-and-half);
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space);
}

.tournament-players-information-setup__img {
    display: flex;
    align-items: center;
    justify-content: center;
}

.tournament-players-information-team-info {
    margin: 0 var(--space-half-quarter);
}

.tournament-players-information__label-state {
    padding: var(--space-quarter) var(--space-half);
    border-radius: var(--space-and-half);
}

.tournament-players-information__label-state.register {
    background-color: var(--new-yellow-color);
}

.tournament-players-information__label-state.enrolled {
    background-color: var(--new-green-color);
}

.tournament-players-information__label-state.rejected {
    background-color: var(--error-color);
}

.tournament-players-information__label-state.baloa-username {
    color: var(--white-color);
}

.tournament-players-information__back-action-container .icon-arrow-left {
    margin-right: var(--space-half);
    cursor: pointer;
}

.tournament-players-information__back-action-container .baloa-subtitle-1 {
    color: var(--primary-dark-color);
}

.tournament-players-information__circle {
    width: var(--space-half-quarter);
    height: var(--space-half-quarter);
    border-radius: 50%;
    background-color: var(--error-color);
}

.tournament-players-information__label-state__container {
    min-width: 130px;
}

.tournament-players-information_options-box__enrolled-container .baloa-names,
.tournament-players-information_options-box__pending-container .baloa-names {
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space-quarter);
}

.tournament-players-information_options-box__enrolled-container .baloa-username,
.tournament-players-information_options-box__pending-container .baloa-username {
    color: var(--primary-dark-color);
}

.tournament-players-information_options-box__enrolled-container,
.tournament-players-information_options-box__pending-container {
    padding: var(--space);
}

.tournament-players-information_options-box__transfer-player {
    margin-top: var(--space);
}

.tournament-players-information__actions .button {
    min-width: 180px;
    padding: var(--space-half-quarter) 0px;
    white-space: nowrap;
    font-size: calc( var(--space) - 1px );
    grid-template-columns: unset;
    grid-template-areas: unset;
}

.tournament-players-information__actions .button.secondary-button {
    border-color: var(--error-color);
    color: var(--error-color);
    margin-top: var(--space);
}

.tournament-players-information__actions .button.secondary-button:hover {
    background-color: unset;
}

.tournament-players-information_filter{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
}

.tournament-players-information_filter_roster{    
    display: flex;
    align-items: center;
    gap: 10px;
}

.tournament-player_information_download_template{
    color: var(--new-green-color);
    display: flex;
    gap: var(--space-half);
    padding: 10px;
    align-items: center;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 4px;
    cursor: pointer;
}

.tournament-player_information_download_template .hubicon-id_card,
.tournament-player_information_download_template .hubicon-roster {
    font-size: 22px;    
}

.tournament-player_information_download_template_text.baloa-table-column{
    color: var(--new-green-color);
}

.tournament-players-information__player-resume-stats {
    padding: 24px;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 16px;
    margin-top: 16px;
}

.tournament-players-information__player-resume-stats__title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
}

.tournament-players-information__player-resume-stats__title .baloa-names {
    color: var(--basic-gray-color);
}

.tournament-players-information__player-resume-stats__stats {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 70px;
    margin-top: 12px;
}

.tournament-players-information__player-resume-stats__stats-col .baloa-table {
    color: var(--basic-gray-color);
    margin-bottom: 4px;
}

.tournament-players-information__player-resume-stats__stats-col .baloa-names {
    color: var(--primary-very-dark-color);    
}

.tournament-players-information__player-resume-stats__title__tooltip .hubicon-help_fill {
    font-size: 20px;    
}

.tournament-players-information__player-resume-stats__title__tooltip .hubicon-help_fill::before {
    color: var(--new-green-color);
    opacity: 0.7;
    cursor: pointer;
}

.tournament-players-information__player-resume-stats__title__tooltip {
    position: relative;
}

.tournament-players-information__player-resume-stats__title__tooltip .baloa-table-column {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
    padding: 13px 10px;
    position: absolute;
    width: 300px;
    height: 116px;
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
    bottom: 42px;
    left: -138px;
    display: none;
}

.tournament-players-information__player-resume-stats__title__tooltip:hover .baloa-table-column {
    display: block;
}

.tournament-players-information__player-resume-stats__title__tooltip .baloa-table-column:after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 50%;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid var(--white-color);
    transform: translateX(-50%);
  }

  .tournament-players-information__profile-stats__state {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .tournament-players-information__profile-stats__state .baloa-username {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
  }

  .tournament-players-information__profile-stats__state .hubicon-lock_fill,
  .tournament-players-information__profile-stats__state .hubicon-lock_open {
    font-size: 18px;
  }

  .tournament-players-information__profile-stats__state .hubicon-lock_fill {
    color: var(--basic-gray-color);
  }

  .tournament-players-information__profile-stats__state .hubicon-lock_open::before {
    color: var(--new-green-color);
  }

.tournament-players-information__button-options__box{
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    width: 300px;
    right: 81px;
    top: 247px;
    display: none;
    border-radius: var(--space-half);
    border: 1px solid var(--new-gray-background-color);
    padding: var(--space-half);
}

.tournament-players-information__button-options__box.active{
    display: block;
    z-index: 1;
}

.tournament-players-information__button-options__box__box-option {
    cursor: pointer;
    border-radius: 8px;
    padding: var(--space-half);
}
.tournament-players-information__button-options__box__box-option:hover {
    background-color: var(--new-background-color);
}

.ttournament-players-information__button-options__box__box-option .baloa-names {
    color: var(--primary-very-dark-color);
}

.tournament-players-information__button-options__box__box-option .baloa-username {
    color: var(--primary-dark-color);
}

.tournament-players-information__checkbox.MuiIconButton-root{
    margin-right: 10px;
    padding: unset;
}

.tournament-players-information__checkbox.MuiCheckbox-root{
    color: var(--primary-dark-color);
    margin: 0;
    width: 5%;
}

.tournament-players-information__cancel-btn .icon,
.tournament-players-information__enroll-btn .icon{
    grid-area: icon;
    font-size: 20px;
    margin-right: 8px;
    font-weight: var(--font-medium);
}

.tournament-players-information__cancel-btn.secondary-button,
.tournament-players-information__enroll-btn.secondary-button {
    padding: 8px 16px;
    margin-left: 10px;
}

.special-actions {
    justify-content: flex-start;
   
}

.tournament-players-information_options-box__download-card {
    text-align: start;
}

.secondary-button.tournament-players-information__share-button{
    padding: 10px 20px;
}

.tournament-players-information__share-button .hubicon-share_v2 {
    grid-area: icon;
    margin-right: 4px;
}

.tournament-players-information__view-more-players.baloa-names {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    color: var(--new-green-color);
    cursor: pointer;
}

.tournament-players-information__team-info__view-btn__label.baloa-table-column {
    color: var(--primary-very-dark-color);
    margin-bottom: 12px;
}

.tournament-players-information__search-filters {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-players-information/TournamentPlayersInformationComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,+CAA+C;IAC/C,sDAAsD;AAC1D;;AAEA;IACI,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,2DAA2D;IAC3D,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,+BAA+B;IAC/B,qCAAqC;IACrC,gDAAgD;IAChD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,4CAA4C;IAC5C,kDAAkD;AACtD;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;;;IAGI,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;IAII,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA;;IAEI,gCAAgC;IAChC,6BAA6B;IAC7B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,yCAAyC;IACzC,qCAAqC;AACzC;;AAEA;;;;IAII,8BAA8B;IAC9B,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,2CAA2C;IAC3C,sCAAsC;IACtC,oCAAoC;IACpC,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;IAC1B,2CAA2C;IAC3C,sCAAsC;IACtC,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,iDAAiD;IACjD,YAAY;IACZ,QAAQ;IACR,MAAM;IACN,yDAAyD;IACzD,aAAa;IACb,gCAAgC;IAChC,kDAAkD;AACtD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,kDAAkD;IAClD,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,+CAA+C;IAC/C,oCAAoC;AACxC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;IACnB,qCAAqC;IACrC,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,kDAAkD;IAClD,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,kDAAkD;IAClD,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;IAClB,oDAAoD;IACpD,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,yCAAyC;IACzC,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,qCAAqC;IACrC,+BAA+B;EACjC;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;AAEF;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,iDAAiD;IACjD,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,gCAAgC;IAChC,kDAAkD;IAClD,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,6CAA6C;AACjD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,SAAS;IACT,SAAS;AACb;;AAEA;;IAEI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;;IAEI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;;AAE/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,SAAS;AACb","sourcesContent":[".tournament-players-information__container {\n    padding: var( --space-and-half );\n    background: var(--white-color);    \n}\n\n.tournament-players-information-team-info .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-players-information-team-info .baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.tournament-players-information-setup__img img {\n    width: 47px;\n    height: 47px;\n    border-radius: 50%;\n}\n\n.tournament-players-information-setup__img .icon-ball {\n    font-size: var(--space-x2);\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: var(--space-half);\n    color: var(--white-color);\n}\n\n.tournament-players-information-setup__team-title{\n    display: flex;\n    align-items: center;    \n    background: rgba(243, 245, 247, 0.6);\n    padding: var(--space-half-quarter) var(--space);\n    border-radius: var(--space-half) var(--space-half) 0 0;    \n}\n\n.tournament-players-information-setup__team-info:first-of-type {\n    width: 35%;\n    justify-content: flex-start;\n}\n\n.tournament-players-information-setup__team-info:last-of-type {\n    width: 20%;\n    justify-content: center;\n}\n\n.tournament-players-information-setup__team-info {\n    display: flex;\n    align-items: center;\n    width: 15%;\n}\n\n.tournament-players-information-setup__team_width{\n    width: 50%;\n    text-align: end;\n    position: relative;\n    cursor: pointer;    \n}\n\n.tournament-players-information-setup__team_width .icon-options {\n    font-weight: var(--font-bold);\n}\n\n.tournament-players-information-setup__filter-container{\n    padding: 12px 16px;\n    width:100%;\n}\n\n.tournament-players-information-player {\n    min-height: calc( var( --space-x3 ) - var( --space-half ) );\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding-left: 4px;\n}\n\n.tournament-players-information-player .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.tournament-players-information-setup__search-input input{\n    background: transparent;\n    width: 100%;\n    border-style: none;\n    font-family: var(--primary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc( var(--space) + 1px );\n    line-height: calc( var(--space-and-half) - 2px );;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.001em;\n    color: var(--basic-gray-color);\n    padding: var(--space-half-quarter) 0;\n}\n\n.tournament-players-information-setup__search-input {\n    width: 32%;\n    background: var(--new-gray-background-color);\n    border-radius: calc( var(--space-and-half) - 2px );\n}\n\n.tournament-players-information-setup__search-input .MuiInput-underline:before,\n.tournament-players-information-setup__search-input .MuiInput-underline:hover:not(.Mui-disabled):before {\n    border: none;\n}\n\n.tournament-players-information-setup__search-input .icon-search {\n    font-size: 20px;\n    margin-left: var( --space-half );\n    margin-right: var( --space-half-quarter );\n    color: #949F9A;\n}\n\n.tournament-players-information-setup__team {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: var(--space-and-half);\n}\n\n.tournament-players-information-setup__team img{\n    height: 39px;\n    width: 39px;\n    border-radius: 50px;\n} \n\n.tournament-players-information-setup__team .icon-ball {\n    font-size: 28px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    height: 100%;\n    color: var(--white-color);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.tournament-players-information-setup__team-data{\n    display: flex;\n    justify-content: initial;\n    align-items: center;\n    width: 248px;\n}\n\n.tournament-players-information-team-btn{\n    display: flex;\n    margin-top: 16px;\n}\n\n.tournament-players-information-btn-actions__payment-info,\n.tournament-players-information-btn-actions__view-form,\n.tournament-players-information-btn-actions__undone {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n\n.tournament-players-information-btn-actions__undone {\n    cursor: auto;\n}\n\n.tournament-players-information-btn-actions__view-form .baloa-table-column,\n.tournament-players-information-btn-actions__payment-info .baloa-table-column,\n.tournament-players-information-team-btn-actions__view-form .baloa-table-column,\n.tournament-players-information-team-btn-actions__payment-info .baloa-table-column {\n    color: var( --new-green-color );\n    margin-right: 10px;\n    padding: 2px 6px;\n    justify-content: center;\n    border-radius: 25px;\n    border: 1px solid var(--new-green-color);\n    background: rgba(48, 179, 107, 0.15);\n}\n\n.tournament-players-information-btn-actions__undone .baloa-table-column,\n.tournament-players-information-team-btn-actions__undone .baloa-table-column {\n    color: var( --basic-gray-color );\n    margin-right: var(--space-x3);\n    padding: 2px 6px;\n    justify-content: center;\n    border-radius: 25px;\n    border: 1px solid var(--basic-gray-color);\n    background: rgba(113, 132, 123, 0.15);\n}\n\n.tournament-players-information-btn-actions__view-form span,\n.tournament-players-information-btn-actions__payment-info span,\n.tournament-players-information-team-btn-actions__view-form span,\n.tournament-players-information-team-btn-actions__payment-info span {\n    color: var(--basic-gray-color);\n    opacity: 0.64;\n    font-size: 20px;\n}\n\n.tournament-players-information-btn-actions__undone span{\n    color: var(--error-color);\n}\n\n.tournament-players-information-team-btn-actions__view-form,\n.tournament-players-information-team-btn-actions__payment-info{\n    margin-right: var(--space-x3);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n\n.tournament-players-information-setup__team-info .baloa-table-column {\n    color: var( --primary-very-dark-color );\n}\n\n.tournament-players-information-setup__team-info:last-of-type .baloa-table-column {\n    margin-right: 84px;\n}\n\n.tournament-players-information-setup__teams-filter {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-players-information__enrolled.baloa-table-column {\n    color: var(--white-color );\n    padding: var( --space-half ) var( --space );\n    border-radius: var( --space-and-half );\n    background:  var( --new-green-color);\n    width: fit-content;\n    margin-left: var(--space-half-quarter);\n}\n\n.tournament-players-information__pending.baloa-table-column {\n    color: var(--white-color );\n    padding: var( --space-half ) var( --space );\n    border-radius: var( --space-and-half );\n    background:  var( --basic-gray-color);\n    width: fit-content;\n}\n\n.tournament-players-information-options{\n    display: flex;\n    align-items: flex-end;\n    position: relative;\n    margin-left: var(--space);\n    cursor: pointer;\n}\n\n.tournament-players-information-options span{\n    font-weight: var(--font-bold);\n}\n\n.tournament-players-information_options-box{\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    width: 380px;\n    right: 0;\n    top: 0;\n    margin-right: calc( var(--space) + var(--space-quarter) );\n    display: none;   \n    border-radius: var(--space-half); \n    border: 1px solid var(--new-gray-background-color);\n}\n\n.tournament-players-information_options-box.active{\n    display: block;    \n}\n\n.tournament-players-information_options-container{\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.tournament-players-information:first-of-type {\n    width: 30%;\n}\n\n.tournament-players-information.staff:first-of-type {\n    width: 35%;\n}\n\n.tournament-players-information:last-of-type {\n    width: 20%;\n}\n\n.tournament-players-information {\n    width: 15%;\n}\n\n.tournament-players-information__back-action-container {\n    display: flex;\n    align-items: center;\n    margin: var(--space-and-half) 0;\n}\n\n.tournament-players-information__players-team__team-info {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.tournament-players-information__team {\n    display: flex;\n    align-items: center;\n    margin-bottom: var(--space-half-quarter);\n}\n\n.tournament-players-information__team-forms {\n    display: flex;\n}\n\n.tournament-players-information__players-team__team-info {\n    padding: var(--space-and-half);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space);\n}\n\n.tournament-players-information-setup__img {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-players-information-team-info {\n    margin: 0 var(--space-half-quarter);\n}\n\n.tournament-players-information__label-state {\n    padding: var(--space-quarter) var(--space-half);\n    border-radius: var(--space-and-half);\n}\n\n.tournament-players-information__label-state.register {\n    background-color: var(--new-yellow-color);\n}\n\n.tournament-players-information__label-state.enrolled {\n    background-color: var(--new-green-color);\n}\n\n.tournament-players-information__label-state.rejected {\n    background-color: var(--error-color);\n}\n\n.tournament-players-information__label-state.baloa-username {\n    color: var(--white-color);\n}\n\n.tournament-players-information__back-action-container .icon-arrow-left {\n    margin-right: var(--space-half);\n    cursor: pointer;\n}\n\n.tournament-players-information__back-action-container .baloa-subtitle-1 {\n    color: var(--primary-dark-color);\n}\n\n.tournament-players-information__circle {\n    width: var(--space-half-quarter);\n    height: var(--space-half-quarter);\n    border-radius: 50%;\n    background-color: var(--error-color);\n}\n\n.tournament-players-information__label-state__container {\n    min-width: 130px;\n}\n\n.tournament-players-information_options-box__enrolled-container .baloa-names,\n.tournament-players-information_options-box__pending-container .baloa-names {\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space-quarter);\n}\n\n.tournament-players-information_options-box__enrolled-container .baloa-username,\n.tournament-players-information_options-box__pending-container .baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.tournament-players-information_options-box__enrolled-container,\n.tournament-players-information_options-box__pending-container {\n    padding: var(--space);\n}\n\n.tournament-players-information_options-box__transfer-player {\n    margin-top: var(--space);\n}\n\n.tournament-players-information__actions .button {\n    min-width: 180px;\n    padding: var(--space-half-quarter) 0px;\n    white-space: nowrap;\n    font-size: calc( var(--space) - 1px );\n    grid-template-columns: unset;\n    grid-template-areas: unset;\n}\n\n.tournament-players-information__actions .button.secondary-button {\n    border-color: var(--error-color);\n    color: var(--error-color);\n    margin-top: var(--space);\n}\n\n.tournament-players-information__actions .button.secondary-button:hover {\n    background-color: unset;\n}\n\n.tournament-players-information_filter{\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 0;\n}\n\n.tournament-players-information_filter_roster{    \n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.tournament-player_information_download_template{\n    color: var(--new-green-color);\n    display: flex;\n    gap: var(--space-half);\n    padding: 10px;\n    align-items: center;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.tournament-player_information_download_template .hubicon-id_card,\n.tournament-player_information_download_template .hubicon-roster {\n    font-size: 22px;    \n}\n\n.tournament-player_information_download_template_text.baloa-table-column{\n    color: var(--new-green-color);\n}\n\n.tournament-players-information__player-resume-stats {\n    padding: 24px;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 16px;\n    margin-top: 16px;\n}\n\n.tournament-players-information__player-resume-stats__title {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px;\n}\n\n.tournament-players-information__player-resume-stats__title .baloa-names {\n    color: var(--basic-gray-color);\n}\n\n.tournament-players-information__player-resume-stats__stats {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 70px;\n    margin-top: 12px;\n}\n\n.tournament-players-information__player-resume-stats__stats-col .baloa-table {\n    color: var(--basic-gray-color);\n    margin-bottom: 4px;\n}\n\n.tournament-players-information__player-resume-stats__stats-col .baloa-names {\n    color: var(--primary-very-dark-color);    \n}\n\n.tournament-players-information__player-resume-stats__title__tooltip .hubicon-help_fill {\n    font-size: 20px;    \n}\n\n.tournament-players-information__player-resume-stats__title__tooltip .hubicon-help_fill::before {\n    color: var(--new-green-color);\n    opacity: 0.7;\n    cursor: pointer;\n}\n\n.tournament-players-information__player-resume-stats__title__tooltip {\n    position: relative;\n}\n\n.tournament-players-information__player-resume-stats__title__tooltip .baloa-table-column {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n    padding: 13px 10px;\n    position: absolute;\n    width: 300px;\n    height: 116px;\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 5px;\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));\n    bottom: 42px;\n    left: -138px;\n    display: none;\n}\n\n.tournament-players-information__player-resume-stats__title__tooltip:hover .baloa-table-column {\n    display: block;\n}\n\n.tournament-players-information__player-resume-stats__title__tooltip .baloa-table-column:after {\n    content: \"\";\n    position: absolute;\n    bottom: -10px;\n    left: 50%;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid var(--white-color);\n    transform: translateX(-50%);\n  }\n\n  .tournament-players-information__profile-stats__state {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .tournament-players-information__profile-stats__state .baloa-username {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n  }\n\n  .tournament-players-information__profile-stats__state .hubicon-lock_fill,\n  .tournament-players-information__profile-stats__state .hubicon-lock_open {\n    font-size: 18px;\n  }\n\n  .tournament-players-information__profile-stats__state .hubicon-lock_fill {\n    color: var(--basic-gray-color);\n  }\n\n  .tournament-players-information__profile-stats__state .hubicon-lock_open::before {\n    color: var(--new-green-color);\n  }\n\n.tournament-players-information__button-options__box{\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    width: 300px;\n    right: 81px;\n    top: 247px;\n    display: none;\n    border-radius: var(--space-half);\n    border: 1px solid var(--new-gray-background-color);\n    padding: var(--space-half);\n}\n\n.tournament-players-information__button-options__box.active{\n    display: block;\n    z-index: 1;\n}\n\n.tournament-players-information__button-options__box__box-option {\n    cursor: pointer;\n    border-radius: 8px;\n    padding: var(--space-half);\n}\n.tournament-players-information__button-options__box__box-option:hover {\n    background-color: var(--new-background-color);\n}\n\n.ttournament-players-information__button-options__box__box-option .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-players-information__button-options__box__box-option .baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.tournament-players-information__checkbox.MuiIconButton-root{\n    margin-right: 10px;\n    padding: unset;\n}\n\n.tournament-players-information__checkbox.MuiCheckbox-root{\n    color: var(--primary-dark-color);\n    margin: 0;\n    width: 5%;\n}\n\n.tournament-players-information__cancel-btn .icon,\n.tournament-players-information__enroll-btn .icon{\n    grid-area: icon;\n    font-size: 20px;\n    margin-right: 8px;\n    font-weight: var(--font-medium);\n}\n\n.tournament-players-information__cancel-btn.secondary-button,\n.tournament-players-information__enroll-btn.secondary-button {\n    padding: 8px 16px;\n    margin-left: 10px;\n}\n\n.special-actions {\n    justify-content: flex-start;\n   \n}\n\n.tournament-players-information_options-box__download-card {\n    text-align: start;\n}\n\n.secondary-button.tournament-players-information__share-button{\n    padding: 10px 20px;\n}\n\n.tournament-players-information__share-button .hubicon-share_v2 {\n    grid-area: icon;\n    margin-right: 4px;\n}\n\n.tournament-players-information__view-more-players.baloa-names {\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n\n.tournament-players-information__team-info__view-btn__label.baloa-table-column {\n    color: var(--primary-very-dark-color);\n    margin-bottom: 12px;\n}\n\n.tournament-players-information__search-filters {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
